import withDataTable from "./withDataTable";
import { 
   getPIP, 
   deletPIPById 
} from "services/pip";
import moment from "moment";

const pathName = "/performance/pdd";
const columns = [
   {
      title: "Name of employee",
      dataIndex: "employeeName",
      key: "employeeName"
   },
   {
      title: "Name of manager",
      dataIndex: "supervisor",
      key: "supervisor"
   },
   {
      title: "Date of PDD/evaluation",
      dataIndex: "dateOfPDD",
      key: "dateOfPDD",
      render: dateOfPDD => dateOfPDD && moment(dateOfPDD).format("DD/MM/YYYY")
   },
   {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: createdAt => createdAt && moment(createdAt).format("DD/MM/YYYY")
   },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
   defaultCurrent = current;
}

if (size) {
   defaultPageSize = size;
}

const getData = () => {
   return getPIP()
};


export default withDataTable({
   title: "Performance Improvement Plan (PIP)",
   addNewLink: "/performance/pip/create",
   updateLink: "/performance/pip/update",
   topFilterItems: [],
   showFilter: false,
   showPagination: true,
   showAddNew: true,
   showButtonInfo: false,
   showButtonSearch: false,
   columns,
   pathName,
   defaultCurrent,
   defaultPageSize,
   getData,
   permission: "PIP",
   confirmSoftDelete: (id) => deletPIPById(id),
});
